var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { connect } from "react-redux";
import { TrackJS } from "trackjs";
import { settingsIncludesRequiredValues } from "helpers/digital_gift_cards";
import { RequestStatus } from "types/requests";
import Loader from "components/loader";
import ErrorPage from "components/digital_gift_cards/error_page";
import PurchasePage from "components/digital_gift_cards/purchase_page";
import { setCreditCardRequestStatus, submitCreditCardPayment, } from "actions/digital_gift_cards";
function DigitalGiftCardsContainer(props) {
    var settingsRequest = props.settingsRequest;
    switch (settingsRequest.type) {
        case RequestStatus.FAILURE: {
            return React.createElement(ErrorPage, null);
        }
        case RequestStatus.SUCCESS: {
            var digitalGiftCardEnabled = settingsRequest.result.digitalGiftCardEnabled;
            var hasRequiredSettings = settingsIncludesRequiredValues(settingsRequest.result);
            if (!hasRequiredSettings) {
                TrackJS.track("digital gift card configuration is missing required settings");
            }
            if (digitalGiftCardEnabled && hasRequiredSettings) {
                return React.createElement(PurchasePage, __assign({ settings: settingsRequest.result }, props));
            }
            return React.createElement(ErrorPage, null);
        }
        default: {
            return (React.createElement("div", { className: "app" },
                React.createElement(Loader, null)));
        }
    }
}
function mapStateToProps(state) {
    return {
        settingsRequest: state.settingsRequest,
        afterProcessedPaymentRequest: state.afterProcessedPaymentRequest,
        creditCardRequestStatus: state.creditCardRequestStatus,
    };
}
var mapDispatchToProps = {
    onSubmitCreditCardPayment: submitCreditCardPayment,
    onSetCreditCardRequestStatus: setCreditCardRequestStatus,
};
var ConnectedDigitalGiftCardsContainer = connect(mapStateToProps, mapDispatchToProps)(DigitalGiftCardsContainer);
export default ConnectedDigitalGiftCardsContainer;
